import 'antd/dist/antd.min.css'
import React, { FC } from 'react'
import { useIcoMenu } from './hooks/useIcoMenu'
import DefaultApp from './app/defaultApp/default-app'
import SurveyApp from './app/surveyApp/survey-app'
import CookieConsent from './components/cookie-consent/cookie-consent'

const App: FC = (props) => {
  const { children } = props
  const isIcoMenu = useIcoMenu()

  return (
    <>
      {isIcoMenu ? <SurveyApp>{children}</SurveyApp> : <DefaultApp>{children}</DefaultApp>}
      <CookieConsent />
    </>
  )
}

export default App
